import cn from 'classnames';
import React from 'react';
import Typography from 'antd/lib/typography';
import { BlockProps } from 'antd/lib/typography/Base';
import { LinkProps } from 'antd/lib/typography/Link';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import { TextProps } from 'antd/lib/typography/Text';
import { TitleProps } from 'antd/lib/typography/Title';

import { FontWeight, TextVariants } from '~/theme/constants';

import './Typo.scss';

export interface SharedTypoProps {
  variant?: TextVariants;
  weight?: FontWeight;
}

export interface ITextProps {
  size?: 'xxs' | 'xs' | 's' | 'p';
}

const { Title: AntTitle, Text: AntText, Paragraph: AntParagraph } = Typography;

const GenericTypo =
  (Typo: React.FC<BlockProps>) =>
  <T extends BlockProps & SharedTypoProps>({
    variant = TextVariants.PRIMARY,
    weight = FontWeight.NORMAL,
    className,
    ...props
  }: T) => {
    const combinedClassName = cn(`fc-${variant}`, `fw-${weight}`, className);
    return <Typo className={combinedClassName} {...props} />;
  };

const Text: React.FC<TextProps & ITextProps & SharedTypoProps> = props => {
  const { size, className, ...restProps } = props;
  const sizeClassName = size && `fs-${size}`;
  return GenericTypo(AntText)({ className: cn(className, sizeClassName), ...restProps });
};

const Title: React.FC<TitleProps & SharedTypoProps> = GenericTypo(AntTitle);
const Link: React.FC<LinkProps & SharedTypoProps> = GenericTypo(Typography.Link as any);
const Paragraph: React.FC<ParagraphProps & SharedTypoProps> = GenericTypo(AntParagraph);

export { Text, Title, Link, Paragraph };
